import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/mangaData';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${manga.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden rounded-lg">
        <img
          src={manga.coverImage}
          alt={`${manga.title} 漫画封面`}
          title={`${manga.title} - 土豪漫画网免费阅读`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            manga.status === '连载中'
              ? 'bg-primary-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}>
            {manga.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2 text-white text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {manga.rating}
            </span>
            <span className="opacity-60">|</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-xs"></i>
              {manga.views > 10000 ? `${(manga.views / 10000).toFixed(1)}万` : manga.views}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors line-clamp-1">
          {manga.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 flex items-center gap-1">
          <i className="ri-user-line text-xs"></i>
          {manga.author}
        </p>
        <div className="flex flex-wrap gap-1 mt-2">
          {manga.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-[10px] whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}